var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5017_1540",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5017_1540",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACsUlEQVRIiWNgGChw7sZ/KWqYw4RL4viJN1FxBVc27qLQIpwW/PvFzXD77gef7v4HW6dt+x9ArgWMuCTO3fgvNWPh5+nnHj01+fvv9y9XU91NkYEM9YaKjB/ItQwrKJz8v90g8tx907Ab/4NynxzddPa/BSn6cfoAGaw9+99i1rIH7a8//HL4/unTHS8XkzW8zxmqGxoY/5HnbAYGht1nf1l0L36cgywWO/F7u37y/eP6Ubf/R1e937j/2n8dsi1omny33Spw29/Q0nsb111EGDR1z38Pz6L3//WjH/y3THl0u2nF/xx85uAEG/f/9/BLPnnVKvrif+ukC//nHEKkpF2P/ktFt/1fqhtz+6lW5KWnGb1flh55hD05442DG6//S3VPf9998eozB0bWv48sLPVOCb9mKISF/eSt/6NWb7pX/eXTLy1hbqYLUYFq3YnejMtI9k3Lgv8lDmm3bxvHXf7vlH3r6sz9CN+svfRfKaL2/3+buNf/HWPP3j98678Ssl4WYiyoSWDsWXH6/45NW+5V8vCJMPDzMbyAybFzQOh///4x/Pnz6w/3P4YfJPsAF+je8D/KPv3+Vb3QS/+9s+6fn7P5fxS6GqLyATrYeO6/1Mq9DN3nr153YPn3j8FARfRAeoJYqY0c4zOKXb145/8Ax7TH51Uir/zXir90u3YV/mRKtA/2n/8vsG7/z8Yjp2/4/fz3h01PX/lMkL9AZZg24zWKXb32xH8Ln8InRw0iLv63TbtwO2/yh3Zi9eL1QUPDf6a3ogz9J09e8vv+/ZeCkpzAgbgolcpgY8YTFLt616P/Ur4Vr/brRl7+bxh54X7hlB8Tz9//L0CxwTDQt+Z/jlrAvr/OmfePLt7/34Ncc3BntH/PGGwMxLbExivEO1K7kmFgYGA4f/899YKDlgAAjqw6GHJ7cXQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCampaign);
export default __webpack_public_path__ + "static/media/active_campaign.51e44385.svg";
export { ForwardRef as ReactComponent };